<p-toast [life]="4000">
    <ng-template pTemplate="message" let-message>
        <div class="flex items-center gap-4">
            @if (message.severity == 'success') {
                <ng-icon name="phosphorCheckCircleFill" class="text-lg overflow-clip"></ng-icon>
            } @else if (message.severity == 'error') {
                <ng-icon name="phosphorXCircleFill" class="text-lg overflow-clip"></ng-icon>
            } @else if (message.severity == 'info') {
                <ng-icon name="phosphorInfoFill" class="text-lg overflow-clip"></ng-icon>
            } @else if (message.severity == 'warn') {
                <ng-icon name="phosphorWarningFill" class="text-lg overflow-clip"></ng-icon>
            } @else if (message.severity == 'secondary') {
                <ng-icon name="phosphorInfoFill" class="text-lg overflow-clip"></ng-icon>
            }

            <p class="font-light leading-none! text-black! text-sm!">{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>

<p-confirmdialog [draggable]="false" [styleClass]="'confirm-dialog'">
    <ng-template #message let-message let-onAccept="onAccept" let-onReject="onReject">
        <div class="flex flex-col items-start gap-3">
            <div class="flex items-center gap-2">
                <ng-icon [name]="message.icon"></ng-icon>
                <p class="font-medium text-black! text-lg!">{{message.header}}</p>
            </div>
            <p class="font-light leading-none! text-text-secondary! text-sm!">{{message.message}}</p>
        </div>
    </ng-template>
</p-confirmdialog>

<router-outlet />
